
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.touchStartX = 0;
        this.touchStartY = 0;

        this.addEventListener('touchstart', (event) => {
          if (!this.isOpen()) return;
          if (event.touches.length !== 1) return;

          this.touchStartX = event.touches[0].clientX;
          this.touchStartY = event.touches[0].clientY;
        }, { passive: true });

        this.addEventListener('touchend', (event) => {
          if (!this.isOpen()) return;
          if (!event.changedTouches.length) return;

          const deltaX =
            event.changedTouches[0].clientX - this.touchStartX;

          const deltaY =
            event.changedTouches[0].clientY - this.touchStartY;

          if (
            Math.abs(deltaX) > 60 &&
            Math.abs(deltaX) > Math.abs(deltaY) * 1.5
          ) {
            this.navigate(deltaX < 0 ? 1 : -1);
          }
        }, { passive: true });

        this.addEventListener('keydown', (event) => {
          if (!this.isOpen()) return;

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.navigate(1);
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.navigate(-1);
          }
        });
      }

      isOpen() {
        return this.hasAttribute('open') ||
          this.classList.contains('active');
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.createNavigation();
      }

      getMediaItems() {
        return Array.from(
          this.querySelectorAll(
            '.product-media-modal__content [data-media-id]'
          )
        );
      }

      getActiveIndex() {
        return this.getMediaItems().findIndex(
          (item) => item.classList.contains('active')
        );
      }

      navigate(direction) {
        const items = this.getMediaItems();

        if (items.length < 2) return;

        const currentIndex = this.getActiveIndex();

        const nextIndex =
          (currentIndex + direction + items.length) %
          items.length;

        items.forEach((item) => {
          item.classList.remove('active');
        });

        const nextItem = items[nextIndex];

        nextItem.classList.add('active');

        nextItem.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        });

        const container =
          this.querySelector('[role="document"]');

        if (container) {
          container.scrollLeft = 0;
        }
      }

      createNavigation() {
        if (this.querySelector('.metux-modal-navigation')) {
          return;
        }

        const navigation = document.createElement('div');
        navigation.className = 'metux-modal-navigation';

        const previous = document.createElement('button');
        previous.type = 'button';
        previous.className = 'metux-modal-prev';
        previous.innerHTML = '&#10094;';
        previous.setAttribute('aria-label', 'Vorige foto');

        const next = document.createElement('button');
        next.type = 'button';
        next.className = 'metux-modal-next';
        next.innerHTML = '&#10095;';
        next.setAttribute('aria-label', 'Volgende foto');

        previous.addEventListener('click', () => {
          this.navigate(-1);
        });

        next.addEventListener('click', () => {
          this.navigate(1);
        });

        navigation.appendChild(previous);
        navigation.appendChild(next);

        this.appendChild(navigation);

        if (!document.getElementById('metux-modal-style')) {
          const style = document.createElement('style');
          style.id = 'metux-modal-style';

          style.textContent = `
            .metux-modal-navigation button {
              position: fixed;
              top: 50%;
              transform: translateY(-50%);
              z-index: 100;
              width: 44px;
              height: 44px;
              border: none;
              border-radius: 50%;
              background: #36abbf;
              color: #ffffff;
              font-size: 22px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              box-shadow: 0 3px 12px rgba(0,0,0,.18);
            }

            .metux-modal-prev {
              left: 18px;
            }

            .metux-modal-next {
              right: 18px;
            }

            .metux-modal-navigation button:hover {
              background: #298fa1;
            }

            @media (max-width: 749px) {
              .metux-modal-navigation button {
                width: 36px;
                height: 36px;
                font-size: 18px;
              }

              .metux-modal-prev {
                left: 8px;
              }

              .metux-modal-next {
                right: 8px;
              }
            }
          `;

          document.head.appendChild(style);
        }
      }

      showActiveMedia() {
        const mediaId =
          this.openedBy.getAttribute('data-media-id');

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        const activeMediaTemplate =
          activeMedia.querySelector('template');

        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container =
          this.querySelector('[role="document"]');

        if (container) {
          container.scrollLeft =
            (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
